import React from 'react';
import ReactDOM from 'react-dom/client';
import "./index.css";
import "./App.css";
import App from './App';
import reportWebVitals from './reportWebVitals';
import { I18nProvider } from './i18n';

// Global error handler for ResizeObserver errors
const originalError = console.error;
console.error = (...args) => {
  if (typeof args[0] === 'string' && args[0].includes('ResizeObserver loop completed with undelivered notifications')) {
    // Ignore ResizeObserver errors as they are not critical and commonly occur during layout transitions
    return;
  }
  originalError.apply(console, args);
};

// Add global error handler for window errors
window.addEventListener('error', (event) => {
  if (event.message.includes('ResizeObserver loop completed with undelivered notifications')) {
    event.preventDefault();
    return false;
  }
});

// Add global error handler for unhandled promise rejections that might contain ResizeObserver errors
window.addEventListener('unhandledrejection', (event) => {
  if (event.reason && event.reason.message && event.reason.message.includes('ResizeObserver')) {
    event.preventDefault();
    return false;
  }
});

// Service Worker registration with automatic update handling
if ('serviceWorker' in navigator) {
  window.addEventListener('load', async () => {
    try {
      const registration = await navigator.serviceWorker.register('/service-worker.js');
      console.log('[SW] Registered successfully');
      
      // Function to activate waiting SW and reload
      const activateWaitingSW = (waitingSW) => {
        console.log('[SW] New version found, activating...');
        waitingSW.postMessage({ type: 'SKIP_WAITING' });
      };
      
      // If there's already a waiting SW, activate it immediately
      if (registration.waiting) {
        console.log('[SW] Waiting SW found on registration, activating...');
        activateWaitingSW(registration.waiting);
      }
      
      // Listen for new SW becoming available
      registration.addEventListener('updatefound', () => {
        const newWorker = registration.installing;
        console.log('[SW] Update found, installing new version...');
        
        newWorker.addEventListener('statechange', () => {
          if (newWorker.state === 'installed' && navigator.serviceWorker.controller) {
            // New SW is installed but waiting - activate it
            console.log('[SW] New version installed, activating...');
            activateWaitingSW(newWorker);
          }
        });
      });
      
      // Reload page when new SW takes over
      let refreshing = false;
      navigator.serviceWorker.addEventListener('controllerchange', () => {
        if (!refreshing) {
          refreshing = true;
          console.log('[SW] New SW activated, reloading page...');
          window.location.reload();
        }
      });
      
      // Check for updates every 5 minutes (in case user keeps tab open)
      setInterval(() => {
        registration.update().catch(err => console.warn('[SW] Update check failed:', err));
      }, 5 * 60 * 1000);
      
    } catch (error) {
      console.warn('[SW] Registration failed:', error);
    }
  });
}

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <I18nProvider>
      <App />
    </I18nProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
